import { render } from "./cadastro_ativo.vue?vue&type=template&id=33e4bebf"
import script from "./cadastro_ativo.vue?vue&type=script&lang=js"
export * from "./cadastro_ativo.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__